export default {
  SEARCH_YOUR_BANK: 'Search your bank',
  VAT: 'VAT',
  TYPE_YOUR_BANK_NAME_TO_FIND: 'Type the name of your bank to find it',
  LOADING_INSTITUTIONS: 'Loading banks…',
  NO_MATCHING_BANK: 'No matching bank',
  CONFIRM: 'Confirm',
  SIGNUP: 'Signup',
  TRANSACTIONS: 'Transactions',
  ACCOUNT: 'Account',
  ADD_COMPANY: 'Add company',
  NAME: 'Name',
  TAX_NUMBER: 'Tax code',
  VAT_NUMBER: 'Vat code',
  WEB: 'Website',
  REQUIRED: ' is required',
  BALANCE: 'Balance',
  FROM: 'From',
  NOTHING_FOUND: 'Nothing found here',
  NO_AVAILABLE_OPTIONS: 'No available options',
  CLEAR_ALL_FILTERS: 'Reset all filters',
  CLEAR_FILTERS: 'Reset filters',
  DATE: 'Date',
  AMOUNT: 'Amount',
  CATEGORY: 'Category',
  CANCEL: 'Cancel',
  SUBMIT: 'Confirm',
  CURRENCY: 'Currency',
  BANK_NOT_LISTED: 'My bank is not listed',
  CURRENCY_IS_REQUIRED: 'Currency is required',
  INVALID_TAX_NUMBER_LENGTH_11: 'Invalid tax number. Length must be 11',
  INVALID_TAX_NUMBER_LENGTH_16: 'Invalid tax number. Length must be 16',
  INVALID_VAT_NUMBER_LENGTH_11: 'Invalid VAT number. Length must be 11',
  NAME_REQUIRED: 'Name is required',
  INVALID_PHONE_NUMBER: 'Invalid mobile number',
  JOIN_COMPANY_ERROR_MESSAGE: 'An error occurred while creating the request',
  JOIN_COMPANY_ALREADY_EXISTS_ERROR_MESSAGE: 'The company is already present among those available',
  ADD_COMPANY_ERROR_MESSAGE: 'An error occurred while creating a company',
  CODE: 'Code',
  SEARCH: 'Search',
  PHONE_NUMBER: 'Mobile',
  INVOICE_ADDED: 'Invoice Added',
  INVOICE_CREATION_ERROR: 'An error occurred while creating the invoice',
  DOCUMENT: 'Document',
  INVOICE_UPDATED: 'Invoice updated',
  INVOICE_UPDATE_ERROR: 'An error occured while updating the invoice',
  HELLO: 'Hello',
  INVOICE: 'Invoice',
  BILLS: 'Bills',
  BILL: 'Bill',
  RECEIPT: 'Receipt',
  OTHER: 'Other',
  COUNTERPART_ISSUED: 'Client',
  COUNTERPART_RECEIVED: 'Supplier',
  DESCRIPTION: 'Description',
  DOCUMENT_DATE: 'Document date',
  FLOW_NUMBER: 'Flow Number',
  INCLUDING_VAT: 'Amount including VAT',
  VAT_PERCENTAGE: 'VAT %',
  DOCUMENT_TYPE: 'Document Type',
  CREATE_FLOWS: 'Create flows',
  PAYMENTS: 'Payments',
  FLOW_NAME: 'Flow Name',
  DUE_DATE: 'Due Date',
  ORIGINAL_DUE_DATE: 'Initial Due Date',
  PAYMENT_DATE: 'Payment Date',
  PAYMENT_STATUS: 'Status',
  PAYMENT_METHOD: 'Payment Method',
  INVOICE_PAYMENT_ACCOUNT: 'Invoice Account',
  PAYMENT_ACCOUNT: 'Payment Account',
  NOTES: 'Notes',
  COUNTERPART_REQUIRED_ISSUED: 'Client is required',
  COUNTERPART_REQUIRED_RECEIVED: 'Supplier is required',
  DOCUMENT_DATE_REQUIRED: 'Document date is required',
  FLOW_NUMBER_REQUIRED: 'Invoice number is required',
  FLOW_NAME_REQUIRED: 'Payment description is required',
  PAYMENT_DATE_REQUIRED: 'Payment date is required',
  PAYMENT_STATUS_REQUIRED: 'Payment status is required',
  SAVE: 'Save',
  WEEK: 'Week',
  MONTH: 'Month',
  ON: 'On',
  DELETE_FLOW: 'Delete',
  PAID_OUTFLOW: 'Paid',
  TO_PAY_OUTFLOW: 'To pay',
  PAID_INFLOW: 'Received',
  TO_PAY_INFLOW: 'To receive',
  PAID_COMBINED: 'Paid/Received',
  TO_PAY_COMBINED: 'To pay/receive',
  PARTIALLY_PAID_INFLOW: 'Partially received',
  PARTIALLY_PAID_OUTFLOW: 'Partially paid',
  TYPE: 'Type',
  TO: 'To',
  FILTERS: 'Filters',
  FILTER: 'Filter',
  CLEAR: 'Clear',
  CONTAINS: 'Contains',
  RECOVER_ENTRATEL_CREDENTIALS: 'Recover your credentials',
  EDIT: 'Edit',
  FLOWS: 'Payments',
  INFLOWS: 'Inflows',
  OUTFLOWS: 'Outflows',
  CREDIT_NOTE: 'Credit note',
  DEBIT_NOTE: 'Debit note',
  SELF_INVOICE: 'Self invoice',
  PARCEL: 'Parcel',
  ERROR_SUBMITTING_FLOW: 'An error occurred while creating the flow',
  TOTAL_VAT_REQUIRED: 'Amount including VAT is required',
  NONE: 'None',
  TRANSFER: 'Transfer',
  CASH: 'Cash',
  CARD: 'Card',
  CHECK: 'Check',
  POSTAL: 'Postal',
  RIBA: 'RIBA',
  SDD: 'SDD',
  TAX_FORM: 'F24',
  FISCAL_CREDIT: 'FiscalCredit',
  DEFERRED: 'Deferred',
  AUTHORIZED: 'Authorized',
  TOTAL: 'Total',
  TOTAL_AMOUNT: 'Amount',
  INVOICES_AND_CREDIT_NOTES: 'Invoices',
  ACTIVE: 'Active',
  SELECT_INSTITUTION: 'Select institution',
  ACCOUNT_NAME: 'Account name',
  CLOSE: 'Close',
  OPEN: 'Open',
  ENTREPRENEUR: 'Entrepreneur',
  EMPLOYEE: 'Employee',
  ADVISOR: 'Advisor',
  THIS_ACTION_CANNOT_BE_UNDONE: 'Do you confirm? This action cannot be undone.',
  PASSWORD: 'Password',
  ERROR: 'Error',
  BANKS: 'Banks',
  TOO_MANY_FLOWS_TO_EXPORT: 'Too many flows to export',
  GO_TO_ACCOUNTS: 'Manage accounts',
  OOPS: 'Oops!',
  ENCOUNTERED_ERROR: "Sorry, we've encountered an error",
  VERIFIED: 'Verified',
  TO_VERIFY: 'To verify',
  VERIFICATION_STATUS: 'Status',
  GETTING_STARTED: 'Getting started',
  FEW_TIPS_TO_GET_BEST: 'Here are few tips to get the best from Sibill',
  CONNECT_YOUR_BANK_ACCOUNT_TITLE: 'Connect your bank account',
  CONNECT_YOUR_BANK_ACCOUNT_DESCRIPTION: 'Enable multi-banking in real time, for you and your team',
  CONNECT_YOUR_INVOICING_SYSTEM_TITLE: 'Connect your invoicing system',
  CONNECT_YOUR_INVOICING_SYSTEM_DESCRIPTION: 'Enable cash flow forecasts, reconciliation, and easy payments',
  START_HERE: 'Start here',
  ALMOST_THERE: 'Almost there!',
  REJECTED: 'Rejected',
  IGNORE: 'Ignore',
  TOTAL_ACCOUNTS: 'Accounts total',
  TOTAL_AVAILABLE_BALANCE_IN_EUR: 'Total available balance in <greenBold>EUR</greenBold>',
  REMOVE: 'Remove',
  DEFAULT: 'Default',
  RECONNECT: 'Reconnect',
  PLAN: 'Plan',
  JOIN_COMPANY_ALREADY_PRESENT_MESSAGE:
    'We forwarded a request for access to the company. We will send you a confirmation email when you receive access to the team.',
  COMPANY_AUTHENTICATION_FAILED: 'Failed to change company',
  ADVISOR_TEXT_1:
    'If you are in charge of the delegated advisor firm, insert the code you usually select in on “Fatture e corrispettivi” on section “2. Scegli per chi operare”. Usually it starts with the fiscal code of the advisor firm',
  ADVISOR_TEXT_2: 'If you are delegated as a freelancer, this field should not be filled',
  TABLE_METADATA_RESULTS: '{{total}} results',
  ACCOUNTING: 'Accounting',
  CONNECT: 'Connect',
  RESTORE: 'Restore',
  REFRESH: 'Refresh',
  ID: 'Id',
  CONTINUE: 'Continue',
  ADD: 'Add',
  DUE_ON: 'Due on {{date}}',
  UPLOAD: 'Upload',
  DEADLINES: 'Deadlines',
  ADD_DEADLINE: 'Add a deadline',
  RENAME: 'Rename',
  CATEGORY_COLOR_PALETTE_LABEL: 'Category color',
  RENAME_CATEGORY_HELP_TEXT: 'Press Enter to confirm',
  UNCATEGORISED: 'Uncategorised',
  LAST_TWELVE_MONTHS_SHORT: 'Last 12 months',
  REMOVE_CATEGORY: 'Remove category',
  MISSING_DOCUMENT: 'The document could not be loaded',
  EXPIRED_DOCUMENT: 'The link to the document has expired. Reload the page',
  TRANSACTIONS_WELCOME_TITLE: 'Welcome to the transactions section!',
  TRANSACTIONS_WELCOME_BODY:
    'In this section you can monitor your receipts and payments.\n' + '\n' + 'Begin by connecting an account.',
  FLOWS_TO_PAY_ON_INFLOW: 'To receive on',
  FLOWS_TO_PAY_ON_OUTFLOW: 'To pay on',
  ERROR_EXPORTING: 'An error occurred while exporting',
  FLOW_UPDATED: 'Payment updated',
  WAITING_FOR_APPROVAL: 'Waiting for approval',
  REMOVED_COMPANY_PAGE_TITLE: 'Welcome',
  REMOVED_COMPANY_PAGE_ADVERTISE_BOX_TITLE: 'Company Unavailable',
  REMOVED_COMPANY_PAGE_ADVERTISE_BOX_DESCRIPTION: 'Sorry, the company you are trying to access is no longer available.',
  UNAUTHORISED_COMPANY_PAGE_TITLE: 'You are not authorised yet',
  UNAUTHORISED_COMPANY_PAGE_ADVERTISE_BOX_TITLE: 'You are not authorised yet',
  UNAUTHORISED_COMPANY_PAGE_ADVERTISE_BOX_DESCRIPTION:
    'We will forward an access request to your company administrator. We will send you a confirmation e-mail when you receive access to the team.',
  LOADING: 'Loading…',
  INVOICES_STATUS_ON_IMPORT_MESSAGE:
    'Invoices with a past payment date will be imported as paid. You will be able to change the payment status after the import.',
  TAB_BANKS_TRANSACTIONS: 'Transactions',
  CASHBOOK: 'Cashbook',
  FILTER_CATEGORIES_SELECTED: '{{count}} categories',
  FILTER_SUBCATEGORIES_SELECTED: '{{count}} subcategories',
  FILTER_PAYMENT_METHOD_LABEL: 'Payment',
  FILTER_PAYMENT_METHODS_SELECTED: '{{count}} methods',
  CUSTOM: 'Custom',
  BACK_TO_TOP: 'Back to top',
  BILLS_FLOWS_TAB_LABEL: 'Receipts',
  ALREADY_REMINDER: 'Already sent reminder on ',
  RECURRENCE: 'Recurrence',
  BACK: 'Back',
  DELIVERY_NOTE: 'Delivery notes',
  QUOTE: 'Quote',
  NEW: 'Novità',
} as const;
